export default __webpack_public_path__ + "static/media/maday.8f55dedd.png";